module.exports = __webpack_public_path__ + "img/mika-2024.e0e56870.jpg";